import styled from "@emotion/styled";

export const TimerWrapper = styled.div<{
  embedded: boolean;
  startedTest: boolean;
}>`
  position: ${(props) => (props.embedded ? "absolute" : "fixed")};
  right: 0;
  z-index: 10;
  width: 100%;
  background: ${(props) => props.theme.colors.white};
  height: 72px;
  top: 0;
  display: ${(props) => (!props.startedTest ? "none" : "flex")};
  justify-content: center;

  @media (min-width: 768px) {
    display: flex;
    height: auto;
    top: ${(props) => (props.embedded ? "-58px" : "24px")};
    right: 36px;
    width: initial;
  }
`;
